export default async function displayRazorpay(callback) {
    const data = await fetch('http://localhost:1337/razorpay', {
      method: 'POST',
    }).then((t) => t.json());
  
    console.log(data);
  
    const options = {
      key: undefined,
      currency: data.currency,
      amount: 501,
      name: 'Learn Code Online',
      description: 'Wallet Transaction',
      image: 'http://localhost:1337/logo.png',
      order_id: data.id,
      handler: function (response) {
        return callback(response);
      },
      prefill: {
        name: 'Anirudh Jwala',
        email: 'anirudh@gmail.com',
        contact: '9999999999',
      },
    };
  
    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  }
  